<template>
  <div class="brief">

    <p>
      深圳市易联通达物流科技发展有限公司成立于2014年，是一家以研发设计、生产、销售智能物流设备为主的智能科技公司。经过近几年的努力，公司不断地发展壮大，公司拥有经验丰富的机械、电气和研发团队，完善的智能操作系统，高效的安装售后人员，为客户提供优质的物流自动化解决方案。
    </p>
    <p>公司拥有核心技术，自主开发软件系统（自主可控，高效运行），稳定可靠，精准控制，并且拥有众多成功项目实施经验。研发推出多款智能物流产品，赢得一大批国内外优质企业的信任与合作，同时自身也获得快速的发展。</p>
    <p>我们致力于将新的人工智能测量技术应用于物流领域，为物流企业提供高效的信息采集服务，以帮助企业达到降低测量成本、提高物流效率、物流智能化等一系列创新和发展的目标。</p>
    <p>公司也根据客户个性化需求，耐心倾听，主动服务，利用敏捷项目开发管理经验，帮助客户实现个性化需求。公司提供7*14小时全天候服务，2小时内响应。</p>
    <img src="../../assets/images/introduce-item.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: "Brief",
  data() {
    return {};
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.brief p {
  text-align: left;
  text-indent: 6px;
  font-family: 微软雅黑;
  letter-spacing: 1px;
  font-size: 13px;
  line-height: 26px;
}
.brief img {
  width: 100%;
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduce/brief.vue